// extracted by mini-css-extract-plugin
module.exports = {"form":"index_form_iCajH","bg":"index_bg_TtnaF","row":"index_row_3DM6A"};